import React from 'react';
import CollegeSuccess from 'shared/college-success/containers';
import Activities from 'shared/portfolio/components/activities/activities';
import CollegeCourses from 'shared/portfolio/components/courses/college-courses/college-courses';
import CommunityService from 'shared/portfolio/components/community-service/community-service';
import HonorAwards from 'shared/portfolio/components/honor-awards/honor-awards';
import Multimedia from 'shared/portfolio/components/multimedia/multimedia-items';
import WorkExperiences from 'shared/portfolio/components/work-experiences/work-experiences';

class TransferPortfolioItems extends React.Component {
  render() {
    return (
      <div>
        <CollegeCourses />
        <HonorAwards />
        <WorkExperiences />
        <Activities />
        <CommunityService />
        <CollegeSuccess
          title="Transfer Success"
          subtitle="Connect With Transfer Destination Colleges"
        />
        <Multimedia />
      </div>
    );
  }
}

export default TransferPortfolioItems;
